// @ts-nocheck
import type { StrictModifiers, Placement, Modifier, Options } from '@popperjs/core'
export declare type SameWidthModifier = Modifier<'sameWidth', Options>;

interface ModifierProps {
  offset?: number
  arrow?: HTMLElement
  arrowOffset?: number
  gpuAcceleration?: boolean
  fallbackPlacements?: Array<Placement>
  sameWidth?: boolean
}

export default function buildModifier (props: ModifierProps, externalModifiers: StrictModifiers[] = []) {
  const {
    arrow,
    arrowOffset,
    offset,
    gpuAcceleration,
    fallbackPlacements,
    sameWidth
  } = props

  const modifiers: Array<StrictModifiers | Partial<SameWidthModifier>> = [
    {
      name: 'offset',
      options: {
        offset: [0, offset ?? 12]
      }
    },
    {
      name: 'preventOverflow',
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    },
    {
      name: 'flip',
      options: {
        padding: 5,
        fallbackPlacements: fallbackPlacements ?? []
      }
    },
    {
      name: 'computeStyles',
      options: {
        gpuAcceleration,
        adaptive: gpuAcceleration
      }
    }
  ]

  if (arrow) {
    modifiers.push({
      name: 'arrow',
      options: {
        element: arrow,
        // the arrow size is an equailateral triangle with 10px side length, the 3rd side length ~ 14.1px
        // adding a offset to the ceil of 4.1 should be 5 this resolves the problem of arrow overflowing out of popper.
        padding: arrowOffset ?? 5
      }
    })
  }

  if (sameWidth) {
    modifiers.push({
      name: 'sameWidth',
      enabled: true,
      fn: ({ state }: any) => {
        state.elements.popper.style.width = `${state.rects.reference.width}px`
        state.rects.popper.width = state.rects.reference.width
      },
      phase: 'beforeRead'
    })
  }

  modifiers.push(...(externalModifiers))
  return modifiers
}
